// import * as tokens from '../../../tokens/typography.generated.js';
export const componentTypography = {
    typography: {}
};
//# sourceMappingURL=component.js.map